/**
 * Module Bootstrap Code.
 *
 * @author Sadi Qevani
 */

(function (window, document, $) {
  "use strict";

  $(function () {

    var carouselConfig = {
      item: 4,
      autoWidth: false,
      slideMove: 1, // slidemove will be 1 if loop is true
      slideMargin: 0,

      addClass: "",
      mode: "slide",
      useCSS: true,
      cssEasing: "ease", //'cubic-bezier(0.25, 0, 0.25, 1)',//
      easing: "linear", //'for jquery animation',////

      speed: 400, //ms'
      auto: false,
      pauseOnHover: false,
      loop: false,
      slideEndAnimation: true,
      pause: 2000,

      keyPress: false,
      controls: true,
      prevHtml: "<i class='icon-arrow-left'></i>",
      nextHtml: "<i class='icon-arrow-right'></i>",

      rtl:false,
      adaptiveHeight:false,

      vertical:false,
      verticalHeight:500,
      vThumbWidth:100,

      thumbItem:10,
      pager: false,
      gallery: false,
      galleryMargin: 5,
      thumbMargin: 5,
      currentPagerPosition: "middle",

      enableTouch: true,
      enableDrag: true,
      freeMove: true,
      swipeThreshold: 40,

      responsive : [
        {
          breakpoint:1024,
          settings: {
            item:3,
            slideMove:1
          }
        },
        {
          breakpoint:768,
          settings: {
            item: 2,
            slideMove:1
          }
        },
        {
          breakpoint: 480,
          settings: {
            item: 1,
            slideMove:1
          }
        }
      ],

      onBeforeStart: function (el) {},
      onSliderLoad: function (el) {},
      onBeforeSlide: function (el) {},
      onAfterSlide: function (el) {},
      onBeforeNextSlide: function (el) {},
      onBeforePrevSlide: function (el) {}
    };

    $(".carousel").lightSlider(carouselConfig);
  });

}(window, document, jQuery));
